import { useEffect, useState } from 'react'

import { Icons } from '@/components/icons'
import { NotificationType } from '@/context/NotificationContext'

interface ToastProps {
    message: string
    type: 'success' | 'error' | 'warning' | 'info'
    onClose: () => void
}

const TOAST_ICONS = {
    success: <Icons.CheckCircle className="w-5 h-5 text-success" />,
    error: <Icons.Asterisk className="w-5 h-5 text-danger" />,
    warning: <Icons.Brain className="w-5 h-5 text-warning" />,
    info: <Icons.Info className="w-5 h-5 text-primary" />
}

export const toast = {
    success: (message: string) => {
        return (
            showNotification: (message: string, type: NotificationType) => void
        ) => {
            showNotification(message, 'success')
        }
    },
    error: (message: string, _p0: any) => {
        return (
            showNotification: (message: string, type: NotificationType) => void
        ) => {
            showNotification(message, 'error')
        }
    }
    // other methods...
}

export function Toast({ message, type, onClose }: ToastProps) {
    const [isVisible, setIsVisible] = useState(true)

    useEffect(() => {
        const timer = setTimeout(() => {
            setIsVisible(false)
            setTimeout(onClose, 300) // Wait for fade out animation
        }, 5000)

        return () => clearTimeout(timer)
    }, [onClose])

    const handleClose = (_p0: any) => {
        setIsVisible(false)
        setTimeout(onClose, 300)
    }

    return (
        <div
            className={`
            transform transition-all duration-300 ease-in-out
            ${isVisible ? 'translate-x-0 opacity-100' : 'translate-x-full opacity-0'}
            flex items-center gap-2 p-4 bg-white dark:bg-gray-800 rounded-lg shadow-lg
            border-l-4 z-50 min-w-[300px]
            ${
                type === 'success'
                    ? 'border-success'
                    : type === 'error'
                      ? 'border-danger'
                      : type === 'warning'
                        ? 'border-warning'
                        : 'border-primary'
            }
        `}
        >
            {TOAST_ICONS[type]}
            <p className="text-sm text-gray-600 dark:text-gray-300">
                {message}
            </p>
            <button
                onClick={handleClose}
                className="ml-auto text-gray-400 hover:text-gray-600 dark:hover:text-gray-200"
            >
                <Icons.Ban className="w-4 h-4" />
            </button>
        </div>
    )
}
